import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
    Component, ElementRef, EventEmitter,
    HostListener,
    Input,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { FolderService } from '@app/shared/common-folder-structure/service/folder.service';
import { OpenAIService } from '@app/shared/services/openai.service';

@Component({
    selector: 'app-ai-prompt',
    templateUrl: './ai-prompt.component.html',
    styleUrls: ['./ai-prompt.component.scss']
})

export class AIPromptComponent implements OnInit {

    promptText:string = '';
    aiLoad:boolean = false;
    emailSubject:string;
    emailBody:string = '';
    selectedTexts:string;
    @Output() cancelEmit = new EventEmitter<string>();
    @Output() insertMailEmit = new EventEmitter<{subject: string;body: string;prompt: string; tone: string[]; rewrite: string[]}>();
    private aiSubscription: any;
    @Input() footerMessage: string;
    @Input() mailContent: string;
    @Input() screenType: string;
    @Input() tags:any;
    showToneOptions = false;
    showRewriteOptions = false;
    selectedToneOptions: string[] = [];
    selectedRewriteOptions: string[] = [];
    @Input() emailHandleTagData: any;
    contentBody:string = '';

    toneOptions = [
        { label: 'Make it sound professional', checked: false },
        { label: 'Make it casual', checked: false }
    ];

    rewriteOptions = [
        { label: 'Make it shorter', checked: false },
        { label: 'Make it longer', checked: false },
        { label: 'Break into bullet points', checked: false },
        { label: 'Simplify', checked: false }
    ];

    @ViewChild('toneDropdown') toneDropdownRef: ElementRef;
    @ViewChild('rewriteDropdown') rewriteDropdownRef: ElementRef;
    @ViewChild('promptInput') promptInput: ElementRef;

    constructor(
        private openaiService: OpenAIService,
        private http: HttpClient,
        private folderService: FolderService,
    ) {

    }

    ngOnInit() {
    }

    ngOnChanges(){
        this.promptInput.nativeElement.focus();
    }

    generatePrompt(type) {
        this.aiLoad = true;
        let notes = '';

            if(this.selectedTexts || type != undefined){
                this.selectedTexts = type;

                notes = this.selectedTexts;
                this.updateOptionCheckboxesFromSelectedText(notes);
                // this.promptText = notes;
            }else {
                notes = this.promptText;
            }
            let data = {
                prompt: notes,
                footer: this.footerMessage,
                body: this.mailContent,
                screenType: this.screenType,
                use_openai:false,
                tablePkId: this.emailHandleTagData['tablePKId'],
                recreate: type != undefined ? true : false
            }
            this.aiSubscription = this.openaiService.generateText(data).subscribe(res=>{

                this.emailHandleTagData['subject'] = res['subject'];
                this.emailHandleTagData['message'] = res['body'];
                let body = this.replaceTags(res['body'],this.tags)
                // this.folderService.getReplacedMessage(this.emailHandleTagData).subscribe((value: any) => {
                //     if (data) {
                this.aiLoad = false;
                this.emailSubject = res['subject'];
                this.selectedTexts = '';
                this.contentBody = this.formatcontentBody(body);
                //     }
                // })
            })


    }

    updateOptionCheckboxesFromSelectedText(selectedText: string) {
        const selectedLabels = selectedText.split(',').map(s => s.trim());

        this.rewriteOptions.forEach(option => {
          option.checked = selectedLabels.includes(option.label);
        });

        this.toneOptions.forEach(option => {
          option.checked = selectedLabels.includes(option.label);
        });
    }

    formatEmailBody(emailBody: string): string {
        emailBody = emailBody.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        emailBody = emailBody.replace(/(?:^|\n)\* (.+)/g, '<li>$1</li>');
        emailBody = emailBody.replace(/(<li>.*<\/li>)/gs, '<ul>$1</ul>');
        emailBody = emailBody.replace(/^<p><br>/, '<p>');
        emailBody = emailBody.replace(/<br><br>/g, '</p><p>');
        if (!emailBody.startsWith('<p>')) {
            emailBody = '<p>' + emailBody;
        }
        if (!emailBody.endsWith('</p>')) {
            emailBody = emailBody + '</p>';
        }
        return emailBody;
    }


    stopLoad(){
        this.aiLoad = false;
        if(this.aiSubscription){
            this.aiSubscription.unsubscribe();
        }
    }

    insertMail(){
        this.selectedToneOptions = this.toneOptions.filter(opt => opt.checked).map(opt => opt.label);
        this.selectedRewriteOptions = this.rewriteOptions.filter(opt => opt.checked).map(opt => opt.label);
        this.insertMailEmit.emit({
            subject: this.emailSubject,
            body: this.contentBody.replace(/<\/p>/g, '</p><br>'),
            prompt: this.promptText,
            tone: this.selectedToneOptions,
            rewrite: this.selectedRewriteOptions
        });
        this.closePanel();
    }

    closePanel(){
        this.aiLoad = false;
        this.promptText = '';
        this.contentBody = '';
        this.emailSubject = '';
        this.showToneOptions = false;
        this.showRewriteOptions = false;
        this.toneOptions.forEach(opt => opt.checked = false);
        this.selectedToneOptions = [];
        this.rewriteOptions.forEach(opt => opt.checked = false);
        this.selectedRewriteOptions = [];
        this.cancelEmit.emit()
    }

    getPrompt(prompt){
        this.promptText = prompt;
    }

    applyOptions(type) {
        this.selectedToneOptions = this.toneOptions.filter(opt => opt.checked).map(opt => opt.label);
        this.selectedRewriteOptions = this.rewriteOptions.filter(opt => opt.checked).map(opt => opt.label);
        const combinedText = [...this.selectedToneOptions, ...this.selectedRewriteOptions].join(', ');
        this.generatePrompt(combinedText)
        if(type == 'rewrite'){
            this.showRewriteOptions = false;
        }else{
            this.showToneOptions = false;
        }
    }

    toggleDropdown(type: 'tone' | 'rewrite') {
        if (type === 'tone') {
            this.showToneOptions = !this.showToneOptions;
            this.showRewriteOptions = false;
        } else {
            this.showRewriteOptions = !this.showRewriteOptions;
            this.showToneOptions = false;
        }
    }

    hasCheckedRewriteOptions(): boolean {
        return this.rewriteOptions.some(opt => opt.checked);
    }

    hasCheckedToneOptions(): boolean {
        return this.toneOptions.some(opt => opt.checked);
    }

    @HostListener('document:click', ['$event'])
    onClickOutside(event: MouseEvent) {
        const target = event.target as HTMLElement;
        if(this.toneDropdownRef) {
            const clickedTone = this.toneDropdownRef.nativeElement.contains(target)
            if (!clickedTone) this.showToneOptions = false;
        }
        if(this.rewriteDropdownRef){
            const clickedRewrite = this.rewriteDropdownRef.nativeElement.contains(target)
            if (!clickedRewrite) this.showRewriteOptions = false;
        }
    }

    replaceTags(template: string, tags: { find: string[]; replace: string[] }) {
        return tags.find.reduce((result, tag, i) => {
          let replacement = tags.replace[i] || "";

          const tagWithBrackets =
            tag.startsWith("[") && tag.endsWith("]") ? tag : `[${tag}]`;
          const tagKey = tagWithBrackets.slice(1, -1);
          let nameKey:any;
          if (replacement.includes("%s")) {
              if(tagKey == 'statement_portal_url')  {
                nameKey = "portal_link" + "_name";
              }else if (tagKey == 'proposal_portal_url'){
                nameKey = "proposal_portal_link" + "_name";
              }else if(tagKey == "upload_media_portal_url"){
                nameKey = "upload_media_portal_link" + "_name";
              }else if(tagKey == "view_media_portal_url"){
                nameKey = "view_media_portal_link" + "_name";
              }else {
                nameKey = tagKey + "_name";
              }
            const nameIndex = tags.find.findIndex(
              (t) => t === `[${nameKey}]` || t === nameKey
            );
            let nameValue = nameIndex >= 0 ? tags.replace[nameIndex] || "" : "";

            if (!nameValue && i + 1 < tags.replace.length) {
              nameValue = tags.replace[i + 1] || "";
            }

            replacement = replacement.replace("%s", nameValue);
          }

          const escapedTag = tagWithBrackets.replace(/[[\]]/g, "\\$&");
          const regex = new RegExp(escapedTag, "g");
          return result.replace(regex, replacement);
        }, template);
    }

    formatcontentBody(contentBody: string): string {
        contentBody = contentBody.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        contentBody = contentBody.replace(/(?:^|\n)\* (.+)/g, '<li>$1</li>');
        contentBody = contentBody.replace(/(<li>.*<\/li>)/gs, '<ul>$1</ul>');
        contentBody = contentBody.replace(/^<p><br>/, '<p>');
        contentBody = contentBody.replace(/<br><br>/g, '</p><p>');
        if (!contentBody.startsWith('<p>')) {
            contentBody = '<p>' + contentBody;
        }
        if (!contentBody.endsWith('</p>')) {
            contentBody = contentBody + '</p>';
        }
        return contentBody;
    }
}
